/* eslint-disable @typescript-eslint/no-explicit-any */
import { reactive } from 'vue';
import { HttpState, Socks4State, Socks5State } from '@/models/FreeProxies';

export const httpState: HttpState = reactive({
  getproxies: 'getproxies',
  type: 'http',
  timeout: 10000,
  country: 'all',
  anonymity: 'all',
  ssl: 'all',
  response: '',
  proxy_info: {
    proxy_count: 0,
    last_updated: '',
  },
});

export const socks4State: Socks4State = reactive({
  getproxies: 'getproxies',
  type: 'socks4',
  timeout: 10000,
  country: 'all',
  response: '',
  proxy_info: {
    proxy_count: 0,
    last_updated: '',
  },
});

export const socks5State: Socks5State = reactive({
  getproxies: 'getproxies',
  type: 'socks5',
  timeout: 10000,
  country: 'all',
  response: '',
  proxy_info: {
    proxy_count: 0,
    last_updated: '',
  },
});

/* console.group();
console.log(httpState.type);
console.log(httpState.timeout);
console.log(httpState.country);
console.log(httpState.anonymity);
console.log(httpState.ssl);
console.groupEnd(); */

export const saveProxies = (response: BlobPart) => {
  const fileURL = window.URL.createObjectURL(new Blob([response]));
  const fURL = document.createElement('a');
  fURL.href = fileURL;
  fURL.setAttribute('download', 'http_proxies.txt');
  document.body.appendChild(fURL);
  fURL.click();
};
